// extracted by mini-css-extract-plugin
module.exports = {"drawerDividerRoot":"styles_drawerDividerRoot__AlAKn"};